import { render } from "./RiDelSm.vue?vue&type=template&id=3d588470"
import script from "./RiDelSm.vue?vue&type=script&lang=js"
export * from "./RiDelSm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiDelSm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d588470"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d588470', __exports__)) {
    api.reload('3d588470', __exports__)
  }
  
  module.hot.accept("./RiDelSm.vue?vue&type=template&id=3d588470", () => {
    api.rerender('3d588470', render)
  })

}


export default __exports__